import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { useLang } from "@/i18n/LanguageContext";

const Section = ({ title, paragraphs }) => (
  <div className="mb-10">
    <h2 className="font-serif text-2xl sm:text-3xl text-[#1A1F24] mb-4">{title}</h2>
    <div className="text-[#4A5568] leading-relaxed space-y-3">
      {paragraphs.map((p) => (
        <p key={p.slice(0, 40)}>{p}</p>
      ))}
    </div>
  </div>
);

const LegalPage = ({ testId, updated, title, sections, backLabel }) => (
  <div data-testid={testId} className="bg-[#F9F6F0] min-h-screen">
    <Header />
    <main className="pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-6 sm:px-12">
        <Link
          to="/"
          data-testid="back-home"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-[#4A5568] hover:text-[#2E4F4F] mb-8 transition-colors"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          {backLabel}
        </Link>
        <p className="text-[#2E4F4F] text-xs uppercase tracking-[0.3em] mb-4">{updated}</p>
        <h1 className="font-serif text-5xl sm:text-6xl text-[#1A1F24] tracking-tight mb-16">
          {title}
        </h1>
        {sections.map((s) => (
          <Section key={s.title} title={s.title} paragraphs={s.paragraphs} />
        ))}
      </div>
    </main>
    <Footer />
  </div>
);

export default LegalPage;

export const useLegalLabels = () => {
  const { lang } = useLang();
  return { back: lang === "es" ? "Inicio" : "Home", lang };
};
